/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AutoSavePressReleaseRequestBody,
    AutoSavePressReleaseRequestBodyFromJSON,
    AutoSavePressReleaseRequestBodyToJSON,
    AutoSavePressReleaseResponse,
    AutoSavePressReleaseResponseFromJSON,
    AutoSavePressReleaseResponseToJSON,
    CreatePressReleaseRequestBody,
    CreatePressReleaseRequestBodyFromJSON,
    CreatePressReleaseRequestBodyToJSON,
    CreatePressReleaseResponse,
    CreatePressReleaseResponseFromJSON,
    CreatePressReleaseResponseToJSON,
    Distributor401Error,
    Distributor401ErrorFromJSON,
    Distributor401ErrorToJSON,
    Distributor404Error,
    Distributor404ErrorFromJSON,
    Distributor404ErrorToJSON,
    Distributor500Error,
    Distributor500ErrorFromJSON,
    Distributor500ErrorToJSON,
    DuplicatePressReleaseSuccessResponse,
    DuplicatePressReleaseSuccessResponseFromJSON,
    DuplicatePressReleaseSuccessResponseToJSON,
    GetPixtaCategoryResponse,
    GetPixtaCategoryResponseFromJSON,
    GetPixtaCategoryResponseToJSON,
    GetPixtaImageResponse,
    GetPixtaImageResponseFromJSON,
    GetPixtaImageResponseToJSON,
    GetPressReleaseCityMasterResponse,
    GetPressReleaseCityMasterResponseFromJSON,
    GetPressReleaseCityMasterResponseToJSON,
    GetPressReleaseEditorMasterResponse,
    GetPressReleaseEditorMasterResponseFromJSON,
    GetPressReleaseEditorMasterResponseToJSON,
    GetPressReleaseHistory404Response,
    GetPressReleaseHistory404ResponseFromJSON,
    GetPressReleaseHistory404ResponseToJSON,
    GetPressReleaseHistory500Response,
    GetPressReleaseHistory500ResponseFromJSON,
    GetPressReleaseHistory500ResponseToJSON,
    GetPressReleaseHistoryList500Response,
    GetPressReleaseHistoryList500ResponseFromJSON,
    GetPressReleaseHistoryList500ResponseToJSON,
    GetPressReleaseHistoryListSuccessResponse,
    GetPressReleaseHistoryListSuccessResponseFromJSON,
    GetPressReleaseHistoryListSuccessResponseToJSON,
    GetPressReleaseHistorySuccessResponse,
    GetPressReleaseHistorySuccessResponseFromJSON,
    GetPressReleaseHistorySuccessResponseToJSON,
    GetPressReleaseMediaListImportedResponse,
    GetPressReleaseMediaListImportedResponseFromJSON,
    GetPressReleaseMediaListImportedResponseToJSON,
    GetPressReleaseMediaListPrtimesResponse,
    GetPressReleaseMediaListPrtimesResponseFromJSON,
    GetPressReleaseMediaListPrtimesResponseToJSON,
    GetPressReleaseMediaListResponse,
    GetPressReleaseMediaListResponseFromJSON,
    GetPressReleaseMediaListResponseToJSON,
    GetPressReleaseResponse,
    GetPressReleaseResponseFromJSON,
    GetPressReleaseResponseToJSON,
    GetPurposeRecommendedReleasesSuccessResponse,
    GetPurposeRecommendedReleasesSuccessResponseFromJSON,
    GetPurposeRecommendedReleasesSuccessResponseToJSON,
    GetPurposeSuccessResponse,
    GetPurposeSuccessResponseFromJSON,
    GetPurposeSuccessResponseToJSON,
    GetShouldShowLimitAlertResponse,
    GetShouldShowLimitAlertResponseFromJSON,
    GetShouldShowLimitAlertResponseToJSON,
    GetStartupChallengeStatusResponse,
    GetStartupChallengeStatusResponseFromJSON,
    GetStartupChallengeStatusResponseToJSON,
    GetTemplateDetailSuccessResponse,
    GetTemplateDetailSuccessResponseFromJSON,
    GetTemplateDetailSuccessResponseToJSON,
    GetTemplateRecommendedReleasesSuccessResponse,
    GetTemplateRecommendedReleasesSuccessResponseFromJSON,
    GetTemplateRecommendedReleasesSuccessResponseToJSON,
    GetTemplatesSuccessResponse,
    GetTemplatesSuccessResponseFromJSON,
    GetTemplatesSuccessResponseToJSON,
    MigratePressReleaseEditorVersionRequestBody,
    MigratePressReleaseEditorVersionRequestBodyFromJSON,
    MigratePressReleaseEditorVersionRequestBodyToJSON,
    MigratePressReleaseEditorVersionResponse,
    MigratePressReleaseEditorVersionResponseFromJSON,
    MigratePressReleaseEditorVersionResponseToJSON,
    ModelError,
    ModelErrorFromJSON,
    ModelErrorToJSON,
    NaturalLanguageAnalyzeEntitiesRequestBody,
    NaturalLanguageAnalyzeEntitiesRequestBodyFromJSON,
    NaturalLanguageAnalyzeEntitiesRequestBodyToJSON,
    NaturalLanguageAnalyzeEntitiesResponse,
    NaturalLanguageAnalyzeEntitiesResponseFromJSON,
    NaturalLanguageAnalyzeEntitiesResponseToJSON,
    PostPressReleaseDocumentFileResponse,
    PostPressReleaseDocumentFileResponseFromJSON,
    PostPressReleaseDocumentFileResponseToJSON,
    PostPressReleaseGifAnimationResponse,
    PostPressReleaseGifAnimationResponseFromJSON,
    PostPressReleaseGifAnimationResponseToJSON,
    PostPressReleaseHistory400Response,
    PostPressReleaseHistory400ResponseFromJSON,
    PostPressReleaseHistory400ResponseToJSON,
    PostPressReleaseHistory401Response,
    PostPressReleaseHistory401ResponseFromJSON,
    PostPressReleaseHistory401ResponseToJSON,
    PostPressReleaseHistory403Response,
    PostPressReleaseHistory403ResponseFromJSON,
    PostPressReleaseHistory403ResponseToJSON,
    PostPressReleaseHistory500Response,
    PostPressReleaseHistory500ResponseFromJSON,
    PostPressReleaseHistory500ResponseToJSON,
    PostPressReleaseHistoryRequestBody,
    PostPressReleaseHistoryRequestBodyFromJSON,
    PostPressReleaseHistoryRequestBodyToJSON,
    PostPressReleaseHistorySuccessAndNoDiffResponse,
    PostPressReleaseHistorySuccessAndNoDiffResponseFromJSON,
    PostPressReleaseHistorySuccessAndNoDiffResponseToJSON,
    PostPressReleaseHistorySuccessResponse,
    PostPressReleaseHistorySuccessResponseFromJSON,
    PostPressReleaseHistorySuccessResponseToJSON,
    PostPressReleaseHistoryToUserHistory400Response,
    PostPressReleaseHistoryToUserHistory400ResponseFromJSON,
    PostPressReleaseHistoryToUserHistory400ResponseToJSON,
    PostPressReleaseHistoryToUserHistory403Response,
    PostPressReleaseHistoryToUserHistory403ResponseFromJSON,
    PostPressReleaseHistoryToUserHistory403ResponseToJSON,
    PostPressReleaseHistoryToUserHistory404Response,
    PostPressReleaseHistoryToUserHistory404ResponseFromJSON,
    PostPressReleaseHistoryToUserHistory404ResponseToJSON,
    PostPressReleaseHistoryToUserHistory500Response,
    PostPressReleaseHistoryToUserHistory500ResponseFromJSON,
    PostPressReleaseHistoryToUserHistory500ResponseToJSON,
    PostPressReleaseHistoryToUserHistorySuccessResponse,
    PostPressReleaseHistoryToUserHistorySuccessResponseFromJSON,
    PostPressReleaseHistoryToUserHistorySuccessResponseToJSON,
    PostPressReleaseImageResponse,
    PostPressReleaseImageResponseFromJSON,
    PostPressReleaseImageResponseToJSON,
    PostPressReleasePdfFileResponse,
    PostPressReleasePdfFileResponseFromJSON,
    PostPressReleasePdfFileResponseToJSON,
    PostPressReleaseWordFileResponse,
    PostPressReleaseWordFileResponseFromJSON,
    PostPressReleaseWordFileResponseToJSON,
    PressReleaseExport400Error,
    PressReleaseExport400ErrorFromJSON,
    PressReleaseExport400ErrorToJSON,
    Purpose401Error,
    Purpose401ErrorFromJSON,
    Purpose401ErrorToJSON,
    SearchPixtaImageResponse,
    SearchPixtaImageResponseFromJSON,
    SearchPixtaImageResponseToJSON,
    Template401Error,
    Template401ErrorFromJSON,
    Template401ErrorToJSON,
    Template404Error,
    Template404ErrorFromJSON,
    Template404ErrorToJSON,
    UpdatePressReleaseEditorBetaFlgRequestBody,
    UpdatePressReleaseEditorBetaFlgRequestBodyFromJSON,
    UpdatePressReleaseEditorBetaFlgRequestBodyToJSON,
    UpdatePressReleaseEditorBetaFlgResponse,
    UpdatePressReleaseEditorBetaFlgResponseFromJSON,
    UpdatePressReleaseEditorBetaFlgResponseToJSON,
    UpdatePressReleaseRequestBody,
    UpdatePressReleaseRequestBodyFromJSON,
    UpdatePressReleaseRequestBodyToJSON,
    UpdatePressReleaseResponse,
    UpdatePressReleaseResponseFromJSON,
    UpdatePressReleaseResponseToJSON,
} from '../models';

export interface AnalyzeEntitiesRequest {
    naturalLanguageAnalyzeEntitiesRequestBody?: NaturalLanguageAnalyzeEntitiesRequestBody;
}

export interface AutoSavePressReleaseRequest {
    releaseId: number;
    autoSavePressReleaseRequestBody?: AutoSavePressReleaseRequestBody;
}

export interface CreatePressReleaseRequest {
    csrfToken: string;
    createPressReleaseRequestBody?: CreatePressReleaseRequestBody;
}

export interface DeletePressReleaseRequest {
    releaseId: number;
    updatePressReleaseRequestBody?: UpdatePressReleaseRequestBody;
}

export interface GetPixtaImageRequest {
    releaseId: number;
    ids: string;
}

export interface GetPressReleaseRequest {
    releaseId: number;
}

export interface GetPressReleaseCityMasterRequest {
    prefId: string;
}

export interface GetPressReleaseMediaListRequest {
    releaseId: number;
}

export interface GetPressReleaseRecommendedReleasesRequest {
    id: number;
}

export interface GetPressReleaseStartupChallengeStatusRequest {
    releaseDate: string;
}

export interface GetTemplateDetailRequest {
    id: number;
}

export interface GetTemplateRecommendedReleasesRequest {
    id: number;
}

export interface MigratePressReleaseEditorVersionRequest {
    releaseId: number;
    migratePressReleaseEditorVersionRequestBody?: MigratePressReleaseEditorVersionRequestBody;
}

export interface PostPressReleaseDocumentFileRequest {
    releaseId: number;
    documentFile: Blob;
}

export interface PostPressReleaseFaxFileRequest {
    releaseId: number;
    documentFile: Blob;
}

export interface PostPressReleaseGifAnimationRequest {
    releaseId: number;
    gifAnimation: Blob;
}

export interface PostPressReleaseImageRequest {
    releaseId: number;
    image: Blob;
}

export interface PostPressReleasePdfFileRequest {
    releaseId: number;
    pdfFile: Blob;
}

export interface PostPressReleaseWordFileRequest {
    releaseId: number;
    wordFile: Blob;
}

export interface PressReleaseReleaseHistorySaveToUserHistoryRequest {
    releaseId: number;
    releaseHistoryId: number;
}

export interface PressReleaseReleaseIdDuplicatePostRequest {
    releaseId: number;
}

export interface PressReleaseReleaseIdExportGetRequest {
    releaseId: number;
    format: string;
    pageSize: string;
}

export interface PressReleaseReleaseIdHistoryGetRequest {
    releaseId: number;
}

export interface PressReleaseReleaseIdHistoryReleaseHistoryIdGetRequest {
    releaseId: number;
    releaseHistoryId: number;
}

export interface PressReleaseReleaseIdPostRequest {
    releaseId: number;
    postPressReleaseHistoryRequestBody?: PostPressReleaseHistoryRequestBody;
}

export interface SearchPixtaImageRequest {
    rows: number;
    page: number;
    searchWord: string;
    categoryId?: number;
}

export interface UpdatePressReleaseRequest {
    releaseId: number;
    updatePressReleaseRequestBody?: UpdatePressReleaseRequestBody;
}

export interface UpdatePressReleaseEditorBetaFlgRequest {
    updatePressReleaseEditorBetaFlgRequestBody?: UpdatePressReleaseEditorBetaFlgRequestBody;
}

/**
 * 
 */
export class PressReleaseEditorApi extends runtime.BaseAPI {

    /**
     * Google Natural Language API を使用した文字列のエンティティ分析を行う
     * NaturalLanguageAnalyzeEntities
     */
    async analyzeEntitiesRaw(requestParameters: AnalyzeEntitiesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<NaturalLanguageAnalyzeEntitiesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/natural_language/analyze_entities`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NaturalLanguageAnalyzeEntitiesRequestBodyToJSON(requestParameters.naturalLanguageAnalyzeEntitiesRequestBody),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NaturalLanguageAnalyzeEntitiesResponseFromJSON(jsonValue));
    }

    /**
     * Google Natural Language API を使用した文字列のエンティティ分析を行う
     * NaturalLanguageAnalyzeEntities
     */
    async analyzeEntities(requestParameters: AnalyzeEntitiesRequest = {}, initOverrides?: RequestInit): Promise<NaturalLanguageAnalyzeEntitiesResponse> {
        const response = await this.analyzeEntitiesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * プレスリリース自動保存API
     * AutoSavePressRelease
     */
    async autoSavePressReleaseRaw(requestParameters: AutoSavePressReleaseRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<AutoSavePressReleaseResponse>> {
        if (requestParameters.releaseId === null || requestParameters.releaseId === undefined) {
            throw new runtime.RequiredError('releaseId','Required parameter requestParameters.releaseId was null or undefined when calling autoSavePressRelease.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/press_release/{release_id}/auto_save`.replace(`{${"release_id"}}`, encodeURIComponent(String(requestParameters.releaseId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AutoSavePressReleaseRequestBodyToJSON(requestParameters.autoSavePressReleaseRequestBody),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AutoSavePressReleaseResponseFromJSON(jsonValue));
    }

    /**
     * プレスリリース自動保存API
     * AutoSavePressRelease
     */
    async autoSavePressRelease(requestParameters: AutoSavePressReleaseRequest, initOverrides?: RequestInit): Promise<AutoSavePressReleaseResponse> {
        const response = await this.autoSavePressReleaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * プレスリリース新規作成API
     * CreatePressRelease
     */
    async createPressReleaseRaw(requestParameters: CreatePressReleaseRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<CreatePressReleaseResponse>> {
        if (requestParameters.csrfToken === null || requestParameters.csrfToken === undefined) {
            throw new runtime.RequiredError('csrfToken','Required parameter requestParameters.csrfToken was null or undefined when calling createPressRelease.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.csrfToken !== undefined && requestParameters.csrfToken !== null) {
            headerParameters['csrf_token'] = String(requestParameters.csrfToken);
        }

        const response = await this.request({
            path: `/press_release`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePressReleaseRequestBodyToJSON(requestParameters.createPressReleaseRequestBody),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreatePressReleaseResponseFromJSON(jsonValue));
    }

    /**
     * プレスリリース新規作成API
     * CreatePressRelease
     */
    async createPressRelease(requestParameters: CreatePressReleaseRequest, initOverrides?: RequestInit): Promise<CreatePressReleaseResponse> {
        const response = await this.createPressReleaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * プレスリリース削除API
     * DeletePressRelease
     */
    async deletePressReleaseRaw(requestParameters: DeletePressReleaseRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<UpdatePressReleaseResponse>> {
        if (requestParameters.releaseId === null || requestParameters.releaseId === undefined) {
            throw new runtime.RequiredError('releaseId','Required parameter requestParameters.releaseId was null or undefined when calling deletePressRelease.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/press_release/{release_id}`.replace(`{${"release_id"}}`, encodeURIComponent(String(requestParameters.releaseId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePressReleaseRequestBodyToJSON(requestParameters.updatePressReleaseRequestBody),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdatePressReleaseResponseFromJSON(jsonValue));
    }

    /**
     * プレスリリース削除API
     * DeletePressRelease
     */
    async deletePressRelease(requestParameters: DeletePressReleaseRequest, initOverrides?: RequestInit): Promise<UpdatePressReleaseResponse> {
        const response = await this.deletePressReleaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * テンプレートの一覧を取得するAPI
     */
    async getListOfTemplatesRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetTemplatesSuccessResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/templates`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTemplatesSuccessResponseFromJSON(jsonValue));
    }

    /**
     * テンプレートの一覧を取得するAPI
     */
    async getListOfTemplates(initOverrides?: RequestInit): Promise<GetTemplatesSuccessResponse> {
        const response = await this.getListOfTemplatesRaw(initOverrides);
        return await response.value();
    }

    /**
     * メディアリスト(インポート)の情報を取得するAPI
     * GetPressReleaseMediaListImported
     */
    async getMediaListImportedRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetPressReleaseMediaListImportedResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/media_list/imported`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPressReleaseMediaListImportedResponseFromJSON(jsonValue));
    }

    /**
     * メディアリスト(インポート)の情報を取得するAPI
     * GetPressReleaseMediaListImported
     */
    async getMediaListImported(initOverrides?: RequestInit): Promise<GetPressReleaseMediaListImportedResponse> {
        const response = await this.getMediaListImportedRaw(initOverrides);
        return await response.value();
    }

    /**
     * メディアリスト(PR TIMES)の情報を取得するAPI
     * GetPressReleaseMediaListPrTimes
     */
    async getMediaListPrtimesRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetPressReleaseMediaListPrtimesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/media_list/prtimes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPressReleaseMediaListPrtimesResponseFromJSON(jsonValue));
    }

    /**
     * メディアリスト(PR TIMES)の情報を取得するAPI
     * GetPressReleaseMediaListPrTimes
     */
    async getMediaListPrtimes(initOverrides?: RequestInit): Promise<GetPressReleaseMediaListPrtimesResponse> {
        const response = await this.getMediaListPrtimesRaw(initOverrides);
        return await response.value();
    }

    /**
     * PIXTAカテゴリ一覧取得API
     * GetPixtaCategory
     */
    async getPixtaCategoryRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetPixtaCategoryResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/press_release/pixta/category`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPixtaCategoryResponseFromJSON(jsonValue));
    }

    /**
     * PIXTAカテゴリ一覧取得API
     * GetPixtaCategory
     */
    async getPixtaCategory(initOverrides?: RequestInit): Promise<GetPixtaCategoryResponse> {
        const response = await this.getPixtaCategoryRaw(initOverrides);
        return await response.value();
    }

    /**
     * PIXTA画像をダウンロードするAPI
     * GetPixtaImage
     */
    async getPixtaImageRaw(requestParameters: GetPixtaImageRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetPixtaImageResponse>> {
        if (requestParameters.releaseId === null || requestParameters.releaseId === undefined) {
            throw new runtime.RequiredError('releaseId','Required parameter requestParameters.releaseId was null or undefined when calling getPixtaImage.');
        }

        if (requestParameters.ids === null || requestParameters.ids === undefined) {
            throw new runtime.RequiredError('ids','Required parameter requestParameters.ids was null or undefined when calling getPixtaImage.');
        }

        const queryParameters: any = {};

        if (requestParameters.releaseId !== undefined) {
            queryParameters['release_id'] = requestParameters.releaseId;
        }

        if (requestParameters.ids !== undefined) {
            queryParameters['ids'] = requestParameters.ids;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/press_release/pixta/image`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPixtaImageResponseFromJSON(jsonValue));
    }

    /**
     * PIXTA画像をダウンロードするAPI
     * GetPixtaImage
     */
    async getPixtaImage(requestParameters: GetPixtaImageRequest, initOverrides?: RequestInit): Promise<GetPixtaImageResponse> {
        const response = await this.getPixtaImageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * プレスリリース編集データを取得するAPI
     * GetPressRelease
     */
    async getPressReleaseRaw(requestParameters: GetPressReleaseRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetPressReleaseResponse>> {
        if (requestParameters.releaseId === null || requestParameters.releaseId === undefined) {
            throw new runtime.RequiredError('releaseId','Required parameter requestParameters.releaseId was null or undefined when calling getPressRelease.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/press_release/{release_id}`.replace(`{${"release_id"}}`, encodeURIComponent(String(requestParameters.releaseId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPressReleaseResponseFromJSON(jsonValue));
    }

    /**
     * プレスリリース編集データを取得するAPI
     * GetPressRelease
     */
    async getPressRelease(requestParameters: GetPressReleaseRequest, initOverrides?: RequestInit): Promise<GetPressReleaseResponse> {
        const response = await this.getPressReleaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * プレスリリースの位置情報(市町村)マスタを取得するAPI
     * GetPressReleaseCityMaster
     */
    async getPressReleaseCityMasterRaw(requestParameters: GetPressReleaseCityMasterRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetPressReleaseCityMasterResponse>> {
        if (requestParameters.prefId === null || requestParameters.prefId === undefined) {
            throw new runtime.RequiredError('prefId','Required parameter requestParameters.prefId was null or undefined when calling getPressReleaseCityMaster.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/press_release/prefecture/{pref_id}`.replace(`{${"pref_id"}}`, encodeURIComponent(String(requestParameters.prefId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPressReleaseCityMasterResponseFromJSON(jsonValue));
    }

    /**
     * プレスリリースの位置情報(市町村)マスタを取得するAPI
     * GetPressReleaseCityMaster
     */
    async getPressReleaseCityMaster(requestParameters: GetPressReleaseCityMasterRequest, initOverrides?: RequestInit): Promise<GetPressReleaseCityMasterResponse> {
        const response = await this.getPressReleaseCityMasterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * プレスリリースエディタのマスターデータを取得するAPI
     * GetPressReleaseEditorMaster
     */
    async getPressReleaseEditorRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetPressReleaseEditorMasterResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/press_release/editor`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPressReleaseEditorMasterResponseFromJSON(jsonValue));
    }

    /**
     * プレスリリースエディタのマスターデータを取得するAPI
     * GetPressReleaseEditorMaster
     */
    async getPressReleaseEditor(initOverrides?: RequestInit): Promise<GetPressReleaseEditorMasterResponse> {
        const response = await this.getPressReleaseEditorRaw(initOverrides);
        return await response.value();
    }

    /**
     * メディアリストの情報を取得するAPI
     * GetPressReleaseMediaList
     */
    async getPressReleaseMediaListRaw(requestParameters: GetPressReleaseMediaListRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetPressReleaseMediaListResponse>> {
        if (requestParameters.releaseId === null || requestParameters.releaseId === undefined) {
            throw new runtime.RequiredError('releaseId','Required parameter requestParameters.releaseId was null or undefined when calling getPressReleaseMediaList.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/press_release/{release_id}/media_list`.replace(`{${"release_id"}}`, encodeURIComponent(String(requestParameters.releaseId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPressReleaseMediaListResponseFromJSON(jsonValue));
    }

    /**
     * メディアリストの情報を取得するAPI
     * GetPressReleaseMediaList
     */
    async getPressReleaseMediaList(requestParameters: GetPressReleaseMediaListRequest, initOverrides?: RequestInit): Promise<GetPressReleaseMediaListResponse> {
        const response = await this.getPressReleaseMediaListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 配信目的のリストを取得するAPI
     * GetPressReleasePurposeList
     */
    async getPressReleasePurposeListRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetPurposeSuccessResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/purposes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPurposeSuccessResponseFromJSON(jsonValue));
    }

    /**
     * 配信目的のリストを取得するAPI
     * GetPressReleasePurposeList
     */
    async getPressReleasePurposeList(initOverrides?: RequestInit): Promise<GetPurposeSuccessResponse> {
        const response = await this.getPressReleasePurposeListRaw(initOverrides);
        return await response.value();
    }

    /**
     * 目的に紐づくおすすめのプレスリリースを取得するAPI
     */
    async getPressReleaseRecommendedReleasesRaw(requestParameters: GetPressReleaseRecommendedReleasesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetPurposeRecommendedReleasesSuccessResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getPressReleaseRecommendedReleases.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/purposes/{id}/recommended_releases`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPurposeRecommendedReleasesSuccessResponseFromJSON(jsonValue));
    }

    /**
     * 目的に紐づくおすすめのプレスリリースを取得するAPI
     */
    async getPressReleaseRecommendedReleases(requestParameters: GetPressReleaseRecommendedReleasesRequest, initOverrides?: RequestInit): Promise<GetPurposeRecommendedReleasesSuccessResponse> {
        const response = await this.getPressReleaseRecommendedReleasesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 定額プランユーザーのプレスリリースが超過請求対象かどうかを確認するAPI
     * GetShouldShowLimitAlert
     */
    async getPressReleaseShouldShowLimitAlertRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetShouldShowLimitAlertResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/press_release/should_show_limit_alert`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetShouldShowLimitAlertResponseFromJSON(jsonValue));
    }

    /**
     * 定額プランユーザーのプレスリリースが超過請求対象かどうかを確認するAPI
     * GetShouldShowLimitAlert
     */
    async getPressReleaseShouldShowLimitAlert(initOverrides?: RequestInit): Promise<GetShouldShowLimitAlertResponse> {
        const response = await this.getPressReleaseShouldShowLimitAlertRaw(initOverrides);
        return await response.value();
    }

    /**
     * スタートアップチャレンジ対象かどうかのステータスを取得するAPI
     * GetStartupChallengeStatus
     */
    async getPressReleaseStartupChallengeStatusRaw(requestParameters: GetPressReleaseStartupChallengeStatusRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetStartupChallengeStatusResponse>> {
        if (requestParameters.releaseDate === null || requestParameters.releaseDate === undefined) {
            throw new runtime.RequiredError('releaseDate','Required parameter requestParameters.releaseDate was null or undefined when calling getPressReleaseStartupChallengeStatus.');
        }

        const queryParameters: any = {};

        if (requestParameters.releaseDate !== undefined) {
            queryParameters['release_date'] = requestParameters.releaseDate;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/press_release/startup_challenge_status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetStartupChallengeStatusResponseFromJSON(jsonValue));
    }

    /**
     * スタートアップチャレンジ対象かどうかのステータスを取得するAPI
     * GetStartupChallengeStatus
     */
    async getPressReleaseStartupChallengeStatus(requestParameters: GetPressReleaseStartupChallengeStatusRequest, initOverrides?: RequestInit): Promise<GetStartupChallengeStatusResponse> {
        const response = await this.getPressReleaseStartupChallengeStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * テンプレートの詳細を取得するAPI
     */
    async getTemplateDetailRaw(requestParameters: GetTemplateDetailRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetTemplateDetailSuccessResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getTemplateDetail.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/templates/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTemplateDetailSuccessResponseFromJSON(jsonValue));
    }

    /**
     * テンプレートの詳細を取得するAPI
     */
    async getTemplateDetail(requestParameters: GetTemplateDetailRequest, initOverrides?: RequestInit): Promise<GetTemplateDetailSuccessResponse> {
        const response = await this.getTemplateDetailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * テンプレートに紐づくおすすめのプレスリリースを取得するAPI
     */
    async getTemplateRecommendedReleasesRaw(requestParameters: GetTemplateRecommendedReleasesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetTemplateRecommendedReleasesSuccessResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getTemplateRecommendedReleases.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/templates/{id}/recommended_releases`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTemplateRecommendedReleasesSuccessResponseFromJSON(jsonValue));
    }

    /**
     * テンプレートに紐づくおすすめのプレスリリースを取得するAPI
     */
    async getTemplateRecommendedReleases(requestParameters: GetTemplateRecommendedReleasesRequest, initOverrides?: RequestInit): Promise<GetTemplateRecommendedReleasesSuccessResponse> {
        const response = await this.getTemplateRecommendedReleasesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * プレスリリースエディタバージョン移行
     * migratePressReleaseEditorVersion
     */
    async migratePressReleaseEditorVersionRaw(requestParameters: MigratePressReleaseEditorVersionRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<MigratePressReleaseEditorVersionResponse>> {
        if (requestParameters.releaseId === null || requestParameters.releaseId === undefined) {
            throw new runtime.RequiredError('releaseId','Required parameter requestParameters.releaseId was null or undefined when calling migratePressReleaseEditorVersion.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/press_release/{release_id}/migrate`.replace(`{${"release_id"}}`, encodeURIComponent(String(requestParameters.releaseId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MigratePressReleaseEditorVersionRequestBodyToJSON(requestParameters.migratePressReleaseEditorVersionRequestBody),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MigratePressReleaseEditorVersionResponseFromJSON(jsonValue));
    }

    /**
     * プレスリリースエディタバージョン移行
     * migratePressReleaseEditorVersion
     */
    async migratePressReleaseEditorVersion(requestParameters: MigratePressReleaseEditorVersionRequest, initOverrides?: RequestInit): Promise<MigratePressReleaseEditorVersionResponse> {
        const response = await this.migratePressReleaseEditorVersionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * メディア向けドキュメントファイル(PDF/PPT/DOC)アップロードAPI
     * postPressReleaseDocumentFile
     */
    async postPressReleaseDocumentFileRaw(requestParameters: PostPressReleaseDocumentFileRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PostPressReleaseDocumentFileResponse>> {
        if (requestParameters.releaseId === null || requestParameters.releaseId === undefined) {
            throw new runtime.RequiredError('releaseId','Required parameter requestParameters.releaseId was null or undefined when calling postPressReleaseDocumentFile.');
        }

        if (requestParameters.documentFile === null || requestParameters.documentFile === undefined) {
            throw new runtime.RequiredError('documentFile','Required parameter requestParameters.documentFile was null or undefined when calling postPressReleaseDocumentFile.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.documentFile !== undefined) {
            formParams.append('document_file', requestParameters.documentFile as any);
        }

        const response = await this.request({
            path: `/press_release/{release_id}/document_file`.replace(`{${"release_id"}}`, encodeURIComponent(String(requestParameters.releaseId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostPressReleaseDocumentFileResponseFromJSON(jsonValue));
    }

    /**
     * メディア向けドキュメントファイル(PDF/PPT/DOC)アップロードAPI
     * postPressReleaseDocumentFile
     */
    async postPressReleaseDocumentFile(requestParameters: PostPressReleaseDocumentFileRequest, initOverrides?: RequestInit): Promise<PostPressReleaseDocumentFileResponse> {
        const response = await this.postPressReleaseDocumentFileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * FAX用ファイル(PDF/PPT/DOC)アップロードAPI
     * postPressReleaseFaxFile
     */
    async postPressReleaseFaxFileRaw(requestParameters: PostPressReleaseFaxFileRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PostPressReleaseDocumentFileResponse>> {
        if (requestParameters.releaseId === null || requestParameters.releaseId === undefined) {
            throw new runtime.RequiredError('releaseId','Required parameter requestParameters.releaseId was null or undefined when calling postPressReleaseFaxFile.');
        }

        if (requestParameters.documentFile === null || requestParameters.documentFile === undefined) {
            throw new runtime.RequiredError('documentFile','Required parameter requestParameters.documentFile was null or undefined when calling postPressReleaseFaxFile.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.documentFile !== undefined) {
            formParams.append('document_file', requestParameters.documentFile as any);
        }

        const response = await this.request({
            path: `/press_release/{release_id}/fax_file`.replace(`{${"release_id"}}`, encodeURIComponent(String(requestParameters.releaseId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostPressReleaseDocumentFileResponseFromJSON(jsonValue));
    }

    /**
     * FAX用ファイル(PDF/PPT/DOC)アップロードAPI
     * postPressReleaseFaxFile
     */
    async postPressReleaseFaxFile(requestParameters: PostPressReleaseFaxFileRequest, initOverrides?: RequestInit): Promise<PostPressReleaseDocumentFileResponse> {
        const response = await this.postPressReleaseFaxFileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * プレスリリースGIFアニメーションアップロードAPI
     * postPressReleaseGifAnimation
     */
    async postPressReleaseGifAnimationRaw(requestParameters: PostPressReleaseGifAnimationRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PostPressReleaseGifAnimationResponse>> {
        if (requestParameters.releaseId === null || requestParameters.releaseId === undefined) {
            throw new runtime.RequiredError('releaseId','Required parameter requestParameters.releaseId was null or undefined when calling postPressReleaseGifAnimation.');
        }

        if (requestParameters.gifAnimation === null || requestParameters.gifAnimation === undefined) {
            throw new runtime.RequiredError('gifAnimation','Required parameter requestParameters.gifAnimation was null or undefined when calling postPressReleaseGifAnimation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.gifAnimation !== undefined) {
            formParams.append('gif_animation', requestParameters.gifAnimation as any);
        }

        const response = await this.request({
            path: `/press_release/{release_id}/gif_animation`.replace(`{${"release_id"}}`, encodeURIComponent(String(requestParameters.releaseId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostPressReleaseGifAnimationResponseFromJSON(jsonValue));
    }

    /**
     * プレスリリースGIFアニメーションアップロードAPI
     * postPressReleaseGifAnimation
     */
    async postPressReleaseGifAnimation(requestParameters: PostPressReleaseGifAnimationRequest, initOverrides?: RequestInit): Promise<PostPressReleaseGifAnimationResponse> {
        const response = await this.postPressReleaseGifAnimationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * プレスリリース画像アップロードAPI
     * postPressReleaseImage
     */
    async postPressReleaseImageRaw(requestParameters: PostPressReleaseImageRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PostPressReleaseImageResponse>> {
        if (requestParameters.releaseId === null || requestParameters.releaseId === undefined) {
            throw new runtime.RequiredError('releaseId','Required parameter requestParameters.releaseId was null or undefined when calling postPressReleaseImage.');
        }

        if (requestParameters.image === null || requestParameters.image === undefined) {
            throw new runtime.RequiredError('image','Required parameter requestParameters.image was null or undefined when calling postPressReleaseImage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.image !== undefined) {
            formParams.append('image', requestParameters.image as any);
        }

        const response = await this.request({
            path: `/press_release/{release_id}/image`.replace(`{${"release_id"}}`, encodeURIComponent(String(requestParameters.releaseId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostPressReleaseImageResponseFromJSON(jsonValue));
    }

    /**
     * プレスリリース画像アップロードAPI
     * postPressReleaseImage
     */
    async postPressReleaseImage(requestParameters: PostPressReleaseImageRequest, initOverrides?: RequestInit): Promise<PostPressReleaseImageResponse> {
        const response = await this.postPressReleaseImageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * プレスリリースPDFファイルアップロードAPI
     * postPressReleasePdfFile
     */
    async postPressReleasePdfFileRaw(requestParameters: PostPressReleasePdfFileRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PostPressReleasePdfFileResponse>> {
        if (requestParameters.releaseId === null || requestParameters.releaseId === undefined) {
            throw new runtime.RequiredError('releaseId','Required parameter requestParameters.releaseId was null or undefined when calling postPressReleasePdfFile.');
        }

        if (requestParameters.pdfFile === null || requestParameters.pdfFile === undefined) {
            throw new runtime.RequiredError('pdfFile','Required parameter requestParameters.pdfFile was null or undefined when calling postPressReleasePdfFile.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.pdfFile !== undefined) {
            formParams.append('pdf_file', requestParameters.pdfFile as any);
        }

        const response = await this.request({
            path: `/press_release/{release_id}/pdf_file`.replace(`{${"release_id"}}`, encodeURIComponent(String(requestParameters.releaseId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostPressReleasePdfFileResponseFromJSON(jsonValue));
    }

    /**
     * プレスリリースPDFファイルアップロードAPI
     * postPressReleasePdfFile
     */
    async postPressReleasePdfFile(requestParameters: PostPressReleasePdfFileRequest, initOverrides?: RequestInit): Promise<PostPressReleasePdfFileResponse> {
        const response = await this.postPressReleasePdfFileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * プレスリリースWordファイルアップロードAPI
     * postPressReleaseWordFile
     */
    async postPressReleaseWordFileRaw(requestParameters: PostPressReleaseWordFileRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PostPressReleaseWordFileResponse>> {
        if (requestParameters.releaseId === null || requestParameters.releaseId === undefined) {
            throw new runtime.RequiredError('releaseId','Required parameter requestParameters.releaseId was null or undefined when calling postPressReleaseWordFile.');
        }

        if (requestParameters.wordFile === null || requestParameters.wordFile === undefined) {
            throw new runtime.RequiredError('wordFile','Required parameter requestParameters.wordFile was null or undefined when calling postPressReleaseWordFile.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.wordFile !== undefined) {
            formParams.append('word_file', requestParameters.wordFile as any);
        }

        const response = await this.request({
            path: `/press_release/{release_id}/word_file`.replace(`{${"release_id"}}`, encodeURIComponent(String(requestParameters.releaseId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostPressReleaseWordFileResponseFromJSON(jsonValue));
    }

    /**
     * プレスリリースWordファイルアップロードAPI
     * postPressReleaseWordFile
     */
    async postPressReleaseWordFile(requestParameters: PostPressReleaseWordFileRequest, initOverrides?: RequestInit): Promise<PostPressReleaseWordFileResponse> {
        const response = await this.postPressReleaseWordFileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * プレスリリースの変更履歴をuser_historyに保存するAPI
     * SavePressReleaseHistoryToUserHistory
     */
    async pressReleaseReleaseHistorySaveToUserHistoryRaw(requestParameters: PressReleaseReleaseHistorySaveToUserHistoryRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PostPressReleaseHistoryToUserHistorySuccessResponse>> {
        if (requestParameters.releaseId === null || requestParameters.releaseId === undefined) {
            throw new runtime.RequiredError('releaseId','Required parameter requestParameters.releaseId was null or undefined when calling pressReleaseReleaseHistorySaveToUserHistory.');
        }

        if (requestParameters.releaseHistoryId === null || requestParameters.releaseHistoryId === undefined) {
            throw new runtime.RequiredError('releaseHistoryId','Required parameter requestParameters.releaseHistoryId was null or undefined when calling pressReleaseReleaseHistorySaveToUserHistory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/press_release/{release_id}/history/{release_history_id}`.replace(`{${"release_id"}}`, encodeURIComponent(String(requestParameters.releaseId))).replace(`{${"release_history_id"}}`, encodeURIComponent(String(requestParameters.releaseHistoryId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostPressReleaseHistoryToUserHistorySuccessResponseFromJSON(jsonValue));
    }

    /**
     * プレスリリースの変更履歴をuser_historyに保存するAPI
     * SavePressReleaseHistoryToUserHistory
     */
    async pressReleaseReleaseHistorySaveToUserHistory(requestParameters: PressReleaseReleaseHistorySaveToUserHistoryRequest, initOverrides?: RequestInit): Promise<PostPressReleaseHistoryToUserHistorySuccessResponse> {
        const response = await this.pressReleaseReleaseHistorySaveToUserHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * プレスリリースの複製を作成するAPI
     * DuplicatePressRelease
     */
    async pressReleaseReleaseIdDuplicatePostRaw(requestParameters: PressReleaseReleaseIdDuplicatePostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<DuplicatePressReleaseSuccessResponse>> {
        if (requestParameters.releaseId === null || requestParameters.releaseId === undefined) {
            throw new runtime.RequiredError('releaseId','Required parameter requestParameters.releaseId was null or undefined when calling pressReleaseReleaseIdDuplicatePost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/press_release/{release_id}/duplicate`.replace(`{${"release_id"}}`, encodeURIComponent(String(requestParameters.releaseId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DuplicatePressReleaseSuccessResponseFromJSON(jsonValue));
    }

    /**
     * プレスリリースの複製を作成するAPI
     * DuplicatePressRelease
     */
    async pressReleaseReleaseIdDuplicatePost(requestParameters: PressReleaseReleaseIdDuplicatePostRequest, initOverrides?: RequestInit): Promise<DuplicatePressReleaseSuccessResponse> {
        const response = await this.pressReleaseReleaseIdDuplicatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * プレスリリースエクスポートAPI
     * GetPressReleaseExport
     */
    async pressReleaseReleaseIdExportGetRaw(requestParameters: PressReleaseReleaseIdExportGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.releaseId === null || requestParameters.releaseId === undefined) {
            throw new runtime.RequiredError('releaseId','Required parameter requestParameters.releaseId was null or undefined when calling pressReleaseReleaseIdExportGet.');
        }

        if (requestParameters.format === null || requestParameters.format === undefined) {
            throw new runtime.RequiredError('format','Required parameter requestParameters.format was null or undefined when calling pressReleaseReleaseIdExportGet.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling pressReleaseReleaseIdExportGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.format !== undefined) {
            queryParameters['format'] = requestParameters.format;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/press_release/{release_id}/export`.replace(`{${"release_id"}}`, encodeURIComponent(String(requestParameters.releaseId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * プレスリリースエクスポートAPI
     * GetPressReleaseExport
     */
    async pressReleaseReleaseIdExportGet(requestParameters: PressReleaseReleaseIdExportGetRequest, initOverrides?: RequestInit): Promise<Blob> {
        const response = await this.pressReleaseReleaseIdExportGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * プレスリリースの履歴一覧を取得するAPI
     * GetPressReleaseHistoryList
     */
    async pressReleaseReleaseIdHistoryGetRaw(requestParameters: PressReleaseReleaseIdHistoryGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetPressReleaseHistoryListSuccessResponse>> {
        if (requestParameters.releaseId === null || requestParameters.releaseId === undefined) {
            throw new runtime.RequiredError('releaseId','Required parameter requestParameters.releaseId was null or undefined when calling pressReleaseReleaseIdHistoryGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/press_release/{release_id}/history`.replace(`{${"release_id"}}`, encodeURIComponent(String(requestParameters.releaseId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPressReleaseHistoryListSuccessResponseFromJSON(jsonValue));
    }

    /**
     * プレスリリースの履歴一覧を取得するAPI
     * GetPressReleaseHistoryList
     */
    async pressReleaseReleaseIdHistoryGet(requestParameters: PressReleaseReleaseIdHistoryGetRequest, initOverrides?: RequestInit): Promise<GetPressReleaseHistoryListSuccessResponse> {
        const response = await this.pressReleaseReleaseIdHistoryGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * プレスリリースの履歴詳細を取得するAPI
     * GetPressReleaseHistoryDetail
     */
    async pressReleaseReleaseIdHistoryReleaseHistoryIdGetRaw(requestParameters: PressReleaseReleaseIdHistoryReleaseHistoryIdGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetPressReleaseHistorySuccessResponse>> {
        if (requestParameters.releaseId === null || requestParameters.releaseId === undefined) {
            throw new runtime.RequiredError('releaseId','Required parameter requestParameters.releaseId was null or undefined when calling pressReleaseReleaseIdHistoryReleaseHistoryIdGet.');
        }

        if (requestParameters.releaseHistoryId === null || requestParameters.releaseHistoryId === undefined) {
            throw new runtime.RequiredError('releaseHistoryId','Required parameter requestParameters.releaseHistoryId was null or undefined when calling pressReleaseReleaseIdHistoryReleaseHistoryIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/press_release/{release_id}/history/{release_history_id}`.replace(`{${"release_id"}}`, encodeURIComponent(String(requestParameters.releaseId))).replace(`{${"release_history_id"}}`, encodeURIComponent(String(requestParameters.releaseHistoryId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPressReleaseHistorySuccessResponseFromJSON(jsonValue));
    }

    /**
     * プレスリリースの履歴詳細を取得するAPI
     * GetPressReleaseHistoryDetail
     */
    async pressReleaseReleaseIdHistoryReleaseHistoryIdGet(requestParameters: PressReleaseReleaseIdHistoryReleaseHistoryIdGetRequest, initOverrides?: RequestInit): Promise<GetPressReleaseHistorySuccessResponse> {
        const response = await this.pressReleaseReleaseIdHistoryReleaseHistoryIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * プレスリリースの履歴を保存するAPI
     * SavePressReleaseHistory
     */
    async pressReleaseReleaseIdPostRaw(requestParameters: PressReleaseReleaseIdPostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PostPressReleaseHistorySuccessAndNoDiffResponse>> {
        if (requestParameters.releaseId === null || requestParameters.releaseId === undefined) {
            throw new runtime.RequiredError('releaseId','Required parameter requestParameters.releaseId was null or undefined when calling pressReleaseReleaseIdPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/press_release/{release_id}/history`.replace(`{${"release_id"}}`, encodeURIComponent(String(requestParameters.releaseId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostPressReleaseHistoryRequestBodyToJSON(requestParameters.postPressReleaseHistoryRequestBody),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostPressReleaseHistorySuccessAndNoDiffResponseFromJSON(jsonValue));
    }

    /**
     * プレスリリースの履歴を保存するAPI
     * SavePressReleaseHistory
     */
    async pressReleaseReleaseIdPost(requestParameters: PressReleaseReleaseIdPostRequest, initOverrides?: RequestInit): Promise<PostPressReleaseHistorySuccessAndNoDiffResponse> {
        const response = await this.pressReleaseReleaseIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * PIXTA画像検索API
     * SearchPixtaImage
     */
    async searchPixtaImageRaw(requestParameters: SearchPixtaImageRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<SearchPixtaImageResponse>> {
        if (requestParameters.rows === null || requestParameters.rows === undefined) {
            throw new runtime.RequiredError('rows','Required parameter requestParameters.rows was null or undefined when calling searchPixtaImage.');
        }

        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page','Required parameter requestParameters.page was null or undefined when calling searchPixtaImage.');
        }

        if (requestParameters.searchWord === null || requestParameters.searchWord === undefined) {
            throw new runtime.RequiredError('searchWord','Required parameter requestParameters.searchWord was null or undefined when calling searchPixtaImage.');
        }

        const queryParameters: any = {};

        if (requestParameters.rows !== undefined) {
            queryParameters['rows'] = requestParameters.rows;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.searchWord !== undefined) {
            queryParameters['search_word'] = requestParameters.searchWord;
        }

        if (requestParameters.categoryId !== undefined) {
            queryParameters['category_id'] = requestParameters.categoryId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/press_release/pixta/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchPixtaImageResponseFromJSON(jsonValue));
    }

    /**
     * PIXTA画像検索API
     * SearchPixtaImage
     */
    async searchPixtaImage(requestParameters: SearchPixtaImageRequest, initOverrides?: RequestInit): Promise<SearchPixtaImageResponse> {
        const response = await this.searchPixtaImageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * プレスリリース更新API
     * UpdatePressRelease
     */
    async updatePressReleaseRaw(requestParameters: UpdatePressReleaseRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<UpdatePressReleaseResponse>> {
        if (requestParameters.releaseId === null || requestParameters.releaseId === undefined) {
            throw new runtime.RequiredError('releaseId','Required parameter requestParameters.releaseId was null or undefined when calling updatePressRelease.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/press_release/{release_id}`.replace(`{${"release_id"}}`, encodeURIComponent(String(requestParameters.releaseId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePressReleaseRequestBodyToJSON(requestParameters.updatePressReleaseRequestBody),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdatePressReleaseResponseFromJSON(jsonValue));
    }

    /**
     * プレスリリース更新API
     * UpdatePressRelease
     */
    async updatePressRelease(requestParameters: UpdatePressReleaseRequest, initOverrides?: RequestInit): Promise<UpdatePressReleaseResponse> {
        const response = await this.updatePressReleaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ベータ版フラグを切り替えるAPI
     * UpdatePressReleaseEditorBataFlg
     */
    async updatePressReleaseEditorBetaFlgRaw(requestParameters: UpdatePressReleaseEditorBetaFlgRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<UpdatePressReleaseEditorBetaFlgResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/press_release/beta_flg`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePressReleaseEditorBetaFlgRequestBodyToJSON(requestParameters.updatePressReleaseEditorBetaFlgRequestBody),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdatePressReleaseEditorBetaFlgResponseFromJSON(jsonValue));
    }

    /**
     * ベータ版フラグを切り替えるAPI
     * UpdatePressReleaseEditorBataFlg
     */
    async updatePressReleaseEditorBetaFlg(requestParameters: UpdatePressReleaseEditorBetaFlgRequest = {}, initOverrides?: RequestInit): Promise<UpdatePressReleaseEditorBetaFlgResponse> {
        const response = await this.updatePressReleaseEditorBetaFlgRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
